export default __webpack_public_path__ + "static/media/gallery_01.296c7b20.jpg";